import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

const colSpan = {
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
  5: 'col-span-5',
  6: 'col-span-6',
  7: 'col-span-7',
  8: 'col-span-8',
  9: 'col-span-9',
  10: 'col-span-10',
  11: 'col-span-11',
  12: 'col-span-12'
}
const smColSpan = {
  1: 'sm:col-span-1',
  2: 'sm:col-span-2',
  3: 'sm:col-span-3',
  4: 'sm:col-span-4',
  5: 'sm:col-span-5',
  6: 'sm:col-span-6',
  7: 'sm:col-span-7',
  8: 'sm:col-span-8',
  9: 'sm:col-span-9',
  10: 'sm:col-span-10',
  11: 'sm:col-span-11',
  12: 'sm:col-span-12'
}
const mdColSpan = {
  1: 'md:col-span-1',
  2: 'md:col-span-2',
  3: 'md:col-span-3',
  4: 'md:col-span-4',
  5: 'md:col-span-5',
  6: 'md:col-span-6',
  7: 'md:col-span-7',
  8: 'md:col-span-8',
  9: 'md:col-span-9',
  10: 'md:col-span-10',
  11: 'md:col-span-11',
  12: 'md:col-span-12'
}
const lgColSpan = {
  1: 'lg:col-span-1',
  2: 'lg:col-span-2',
  3: 'lg:col-span-3',
  4: 'lg:col-span-4',
  5: 'lg:col-span-5',
  6: 'lg:col-span-6',
  7: 'lg:col-span-7',
  8: 'lg:col-span-8',
  9: 'lg:col-span-9',
  10: 'lg:col-span-10',
  11: 'lg:col-span-11',
  12: 'lg:col-span-12'
}
const spacingToGap = {
  1: 'gap-2',
  2: 'gap-4',
  3: 'gap-6',
  4: 'gap-8',
  5: 'gap-10',
  6: 'gap-12',
  7: 'gap-14',
  8: 'gap-16',
  10: 'gap-20',
  12: 'gap-24'
}

const xlColSpan = {
  1: 'xl:col-span-1',
  2: 'xl:col-span-2',
  3: 'xl:col-span-3',
  4: 'xl:col-span-4',
  5: 'xl:col-span-5',
  6: 'xl:col-span-6',
  7: 'xl:col-span-7',
  8: 'xl:col-span-8',
  9: 'xl:col-span-9',
  10: 'xl:col-span-10',
  11: 'xl:col-span-11',
  12: 'xl:col-span-12'
}

export const AdasGrid = ({
  children,
  className,
  container,
  item,
  xs,
  sm,
  md,
  lg,
  xl,
  spacing,
  // MUI system props - strip to prevent DOM warnings
  // eslint-disable-next-line no-unused-vars
  justifyContent,
  // eslint-disable-next-line no-unused-vars
  alignItems,
  // eslint-disable-next-line no-unused-vars
  mb,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => {
  const classes = cn(
    container && 'grid grid-cols-12',
    container && spacing && spacingToGap[spacing],
    item && xs && colSpan[xs],
    item && sm && smColSpan[sm],
    item && md && mdColSpan[md],
    item && lg && lgColSpan[lg],
    item && xl && xlColSpan[xl],
    className
  )
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  )
}

AdasGrid.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  container: PropTypes.bool,
  item: PropTypes.bool,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  spacing: PropTypes.number
}
